import { render, staticRenderFns } from "./GJgrowEventCreateExamineeSettingStudents.vue?vue&type=template&id=76c24e1c&"
import script from "./GJgrowEventCreateExamineeSettingStudents.vue?vue&type=script&lang=ts&"
export * from "./GJgrowEventCreateExamineeSettingStudents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports